import { createListViewContainer } from 'factories/ListView'
import selectors from 'selectors'
import actions from 'actions/formBatches'
import Component from 'components/FormBatches'

export default createListViewContainer({ actions, selectors: selectors.formBatches })(Component)
